import { Form, Formik } from "formik";
import { Button, Input, Upload } from "../../../custom";
import styles from "../styles.module.scss";
import { FC, useEffect, useState } from "react";
import { Image } from "antd";
import { ReactComponent as FileIcon } from "../../../assets/file.svg";
import { object } from "yup";
import { validator } from "../../../utils/validator";
import {
  isImageUrl,
  PDF_IMAGE_ACCEPT,
  PDF_IMAGE_FORMAT_LABELS,
} from "../../../utils/fileValidation";

interface ComponentProps {
  editIndex: number | null;
  institution?: Institution[];
  isLoading: boolean;
  buttonText: string;
  certificateUrl?: string;
  onSubmit: (values: Institution) => void;
}

const InstitutionForm: FC<ComponentProps> = ({
  buttonText,
  certificateUrl,
  editIndex,
  institution,
  isLoading,
  onSubmit,
}) => {
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    setImageUrl(certificateUrl ?? "");
  }, [certificateUrl]);

  const handleRemoveImageUrl = () => {
    setImageUrl("");
  };

  const validationSchema = object().shape({
    institutionName: validator.institutionName,
    discipline: validator.discipline,
    cgpa: validator.cgpa,
    startDate: validator.startDate,
    endDate: validator.endDate,
    upload: validator.upload,
  });

  return (
    <Formik<Institution>
      initialValues={
        editIndex !== null && institution
          ? institution[editIndex]
          : {
              institutionName: "",
              discipline: "",
              cgpa: "",
              startDate: "",
              endDate: "",
              upload: null,
            }
      }
      validationSchema={validationSchema}
      onSubmit={(values) => {
        onSubmit(values);
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <Form>
            <div className={styles.formWrapper}>
              <Input
                name="institutionName"
                label="Institution attended"
                placeholder="Enter institution"
              />
              <Input
                name="discipline"
                label="Discipline"
                placeholder="Enter discipline"
              />
              <Input
                type="number"
                name="cgpa"
                label="CGPA"
                placeholder="Enter CGPA"
              />

              <section className={styles.grid}>
                <Input
                  name="startDate"
                  type="date"
                  label="Start Date"
                  placeholder="Enter date"
                />

                <Input
                  name="endDate"
                  type="date"
                  label="End Date"
                  placeholder="Enter date"
                />
              </section>
            </div>

            <br />

            {certificateUrl ? (
              <div className="small-gap">
                <div className={styles.image}>
                  {isImageUrl(imageUrl) ? (
                    <Image
                      width={120}
                      height={100}
                      src={imageUrl}
                      alt="Certificate"
                    />
                  ) : (
                    <a
                      href={imageUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={styles.certificateLink}
                    >
                      <FileIcon width={48} height={48} />
                    </a>
                  )}
                </div>
                <Button
                  onClick={handleRemoveImageUrl}
                  text="x"
                  className={styles.cancel}
                />
              </div>
            ) : (
              <Upload
                name="upload"
                label="Upload Certificate"
                fileName={values.upload ? values.upload.name : ""}
                accept={PDF_IMAGE_ACCEPT}
                allowedFormats={PDF_IMAGE_FORMAT_LABELS}
                onChange={(e) => {
                  const file = e.target.files;
                  if (file) {
                    setFieldValue("upload", file[0]);
                  }
                }}
              />
            )}

            <br />

            <div className={styles.buttonWrapper}>
              <Button
                type="submit"
                text={buttonText}
                isLoading={isLoading}
                className={styles.buttonSize}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default InstitutionForm;
